const DupTitlesOK = [
    "Fun Fact",
    "HighImpact",
    "CarWarranty",
    "Annual Vet Appt for Horse",
    "Annual Vet Visit",
    "Auto Insurance Increase",
    "Invite Friend to Ride Horse",
    "Storm Damage",
]
export default DupTitlesOK;